// Infrastructure
import fixtures from './fixtures.json';

// Domain
import { SourceRepository } from '../../../domain/repository';
import { SourceEntity } from '../../../domain/entities/source-entity';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class SourceDummyRepository implements SourceRepository {
  // eslint-disable-next-line class-methods-use-this
  execute(): Promise<Array<SourceEntity>> {
    return Promise.resolve(fixtures);
  }
}
